module.exports = __webpack_public_path__ + "img/1439947872.04856df3.jpg";